import React from "react";
import "./Home.css";
import profilePic from "../assets/profile.jpg";
import { ReactTyped } from "react-typed";
import SplitText from "../components/SplitText";
import ProfileCard from "../components/ProfileCard"; // import ProfileCard

const Home = () => {
  return (
    <section className="home-container" id="home">
      <div className="home-content">
        <h1 className="shiny-text">
          Hi, It's <span>Arden</span>
        </h1>
        <h3>
          I'm a{" "}
          <span>
            <ReactTyped
              strings={[
                "Tech Enthusiast",
                "Fullstack Developer",
                "AI & ML Explorer",
                "Software Engineer",
              ]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
          </span>
        </h3>

        <SplitText
          text="I love exploring how technology can solve real-world problems. My main interests are in Artificial Intelligence, Machine Learning, Web Development and building innovative solutions that make life better."
          className="home-description text-lg text-white"
          delay={20}
          duration={0.6}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="left"
          onLetterAnimationComplete={() =>
            console.log("Description animation completed!")
          }
        />
      </div>

      <div className="home-img">
        <ProfileCard
          name="V. Arden"
          title="Software Engineer"
          handle="ardencodes"
          status="Online"
          contactText="Contact Me"
          avatarUrl={profilePic}
          showUserInfo={true}
          enableTilt={true}
          enableMobileTilt={true}
          onContactClick={() => {
  window.location.href = "https://api.whatsapp.com/send/?phone=%2B628158039952&text&type=phone_number&app_absent=0";
}}
        />
      </div>
    </section>
  );
};

export default Home;
